import React from 'react';
import { Button } from '../../ui/button';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../../ui/dialog';

export default function NewTenancyWarningDialog({ open, onOpenChange, onCancel, onContinue }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="set-expiry-dialog" data-testid="new-tenancy-warning-dialog">
        <DialogHeader>
          <DialogTitle>Start a new tenancy?</DialogTitle>
          <DialogDescription>
            Confirm you want to replace the current tenant data with a new tenancy. The previous tenant snapshot will be archived.
          </DialogDescription>
        </DialogHeader>
        <p className="ai-review-hint" style={{ marginBottom: 12 }}>
          This will <strong>replace the current tenant and tenancy data</strong> on this property with new details (uploaded AST or manual entry).
        </p>
        <ul className="new-tenancy-warning-list">
          <li>The current tenant snapshot (name, rent, dates, contract type, deposit) will be archived into <strong>Previous Tenancies</strong> at the bottom of the Tenant Information card.</li>
          <li>If you upload a new AST, the Documents section will replace the existing Tenancy Agreement with the new file.</li>
          <li>This does not affect utilities, custom property fields, or other documents.</li>
        </ul>
        <div className="ai-review-actions">
          <Button onClick={onCancel} className="btn-secondary" data-testid="new-tenancy-cancel">
            Cancel
          </Button>
          <Button onClick={onContinue} className="btn-primary" data-testid="new-tenancy-continue">
            Continue
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
